  // function scrollToTop2(){
  //   let bundleSection = document.getElementById("customBuyButton");

  //   if (bundleSection) {
  //       console.log("Element found:", bundleSection);
  //       bundleSection.scrollIntoView({
  //           behavior: "smooth", // smooth scrolling
  //           block: "start" // scroll to the top of the element
  //       });

  //   } else {
  //       console.warn("Element not found: #customBuyButton");
  //       window.scrollTo({ top: 0, behavior: 'smooth' });
  //   }
  //  }

function scrollToTop2(){
    let bundleSection = document.getElementById("customBuyButton");

    if (bundleSection) {
        console.log("Element found:", bundleSection);
        
        // Get the position of the element
        let elementPosition = bundleSection.getBoundingClientRect().top + window.scrollY;
        
        // Scroll to the element, offset by 50px from the top
        window.scrollTo({
            top: elementPosition - 50,  // Offset by 50px
            behavior: 'smooth' // Smooth scroll
        });
    } else {
        console.warn("Element not found: #customBuyButton");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
